<template>
  <transition name="dialog-fade">
    <div v-if="show"
         class="dialog-wrap">
      <div class="weui-mask"
           v-if="mask"></div>

      <div class="weui-dialog">
        <div v-if="title && isHtml"
             class="weui-dialog__hd"
             v-html="title">
        </div>
        <div v-else-if="title"
             class="weui-dialog__hd">
          {{title}}
        </div>

        <div class="weui-dialog__bd"
             :class="{'hastitle': title}"
             v-if="isHtml"
             v-html="message"></div>
        <div class="weui-dialog__bd"
             :class="{'hastitle': title}"
             v-else>{{message}}</div>
        <div class="weui-dialog__ft">
          <a v-if="showCancelButton"
             class="weui-dialog__btn weui-dialog__btn_default"
             @click="handleAction('cancel')">{{cancelButtonText}}</a>
          <a v-if="showConfirmButton"
             :class="{'onlybtn':!showCancelButton}"
             class="weui-dialog__btn weui-dialog__btn_color"
             @click="handleAction('confirm')">
            <i v-if="confimisHtml"
               v-html="confirmButtonText"></i>
            <i v-else>{{confirmButtonText}}</i>
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      mask: true,
      title: undefined,

      isHtml: false,
      confimisHtml: false,
      message: '',

      showConfirmButton: true,
      showCancelButton: false,
      confirmButtonText: '',
      cancelButtonText: '',
      callback: null,
    }
  },
  methods: {
    handleAction: function (eventType) {
      if (eventType === "cancel") {
        this.cancel && this.cancel(this);
      }
      if (eventType === "confirm") {
        this.callback && this.callback(this)
      }
      this.showConfirmButton = true;
      this.showCancelButton = false;
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
// 显示过渡动画
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  // transition: opacity 0.5s;
}

.dialog-fade-enter,
.dialog-fade-leave-to {
  // opacity: 0;
}

.dialog-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
}

.weui-mask {
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.7;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.weui-dialog {
  width: 6.7rem;
  text-align: center;
  background-color: #fff;
  border-radius: 0.16rem;
  position: fixed;
  top: 30%;
  left: 50%;
  z-index: 10000;
  margin-left: -3.35rem;
  border-radius: 0.08rem;
  padding: 0rem 0.2rem 0.25rem 0.2rem;
  .weui-dialog__hd {
    font-size: 0.32rem;
    font-weight: 600;
    padding: 0.36rem 0.15rem;
    color: rgb(41, 47, 67);
  }
  .weui-dialog__bd {
    font-size: 0.32rem;
    padding: 0.6rem 0.15rem;
    color: rgb(41, 47, 67);
  }
  .weui-dialog__ft {
    line-height: 0.6rem;
    font-size: 0.3rem;
    border-top: 1px solid rgb(237, 239, 243);
    overflow: hidden;
    .weui-dialog__btn {
      display: inline-block;
      width: 50%;
      line-height: 0.5rem;
      margin-top: 0.15rem;
    }
    .weui-dialog__btn_default {
      color: rgb(190, 193, 191);
      float: left;
    }
    .weui-dialog__btn_color {
      color: rgb(24, 126, 234);
      float: right;
      border-left: 1px solid rgb(237, 239, 243);
    }
  }
}

.hastitle {
  color: rgb(105, 110, 126) !important;
  font-size: 0.26rem !important;
  padding-top: 0rem !important;
}

.onlybtn {
  width: 100% !important;
  border: none !important;
}
</style>
